import HomeIcon from '@mui/icons-material/Home';
import GroupIcon from '@mui/icons-material/Group';
import FeedIcon from '@mui/icons-material/Feed';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import CategoryIcon from '@mui/icons-material/Category';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BarChartIcon from '@mui/icons-material/BarChart';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LogoutIcon from '@mui/icons-material/Logout';

const users_table_headers = [
    {
        id: 1,
        name: 'Ism',
    },
    {
        id: 2,
        name: 'Telefon',
    },
    {
        id: 3,
        name: 'Email',
    },
    {
        id: 4,
        name: 'Haqida',
    },
    {
        id: 5,
        name: 'Role',
    },
    {
        id: 6,
        name: 'Active',
    },
]


const categories_table_headers = [
    {
        id: 1,
        name: 'No',
    },
    {
        id: 2,
        name: 'Nomi',
    },
    {
        id: 3,
        name: '',
    },
]


const status_table_headers = [
    {
        id: 1,
        name: 'No',
    },
    {
        id: 2,
        name: 'Nomi',
    },
    {
        id: 3,
        name: '',
    },
]


const excelTableHeaders = [
    {
        id: 1,
        name: 'No',
    },
    {
        id: 2,
        name: 'Loyiha nomi',
    },
    {
        id: 3,
        name: 'Loyiha statusi',
    },
    {
        id: 24,
        name: 'Ism',
    },
    {
        id: 35,
        name: 'Tel raqami',
    },
    {
        id: 35,
        name: 'Email',
    },
]

const fakulties = [
    {
        name: "moliya",
        id: 1,
        value: "moliya"
    },
    {
        name: "iqtisodiyot",
        id: 2,
        value: "iqtisodiyot"
    },
    {
        name: "sirtqi",
        id: 3,
        value: "sirtqiya"
    },
    {
        name: "magistratura va kechki talim",
        id: 4,
        value: "magistratura va kechki talim"
    },
    {
        name: "bank ishi",
        id: 5,
        value: "bank ishi"
    },
    {
        name: "byudjet hisobi va g'aznachilik",
        id: 6,
        value: "byudjet hisobi va g'aznachilik"
    },
    {
        name: "buxgalteriya hisobi va audit",
        id: 7,
        value: "buxgalteriya hisobi va audit"
    },
    {
        name: "soliqlar va sug'urta",
        id: 8,
        value: "soliqlar va sug'urta"
    },
    {
        name: "boshqalar",
        id: 9,
        value: "boshqalar"
    },
  ]


const navbarData = [
    {
        name: "Bosh sahifa",
        url: "/",
        role: ["admin"],
        icon: <HomeIcon />
    },
    {
        name: "Foydalanuvchilar",
        url: "/users",
        role: ["admin"],
        icon: <GroupIcon />
    },
    {
        name: "Kategoriyalar",
        url: "/categories",
        role: ["admin", "pre-admin"],
        icon: <CategoryIcon />
    },
    {
        name: "Kalendar",
        url: "/calendar",
        role: ["admin", "pre-admin", "user"],
        icon: <CalendarMonthIcon />
    },
    {
        name: "Statistika",
        url: "/statistics",
        role: ["admin", "pre-admin"],
        icon: <BarChartIcon />
    },
    {
        name: "Status",
        url: "/status",
        role: ["admin", "pre-admin"],
        icon: <AutorenewIcon />
    },
    {
        name: "Yutuqlar",
        url: "/awards",
        role: ["user", "pre-admin", "admin"],
        icon: <EmojiEventsIcon />
    },
    {
        name: "Investitsiyalar",
        url: "/support",
        role: ["user", "pre-admin", "admin"],
        icon: <CurrencyExchangeIcon />
    },
    {
        name: "Yangiliklar (WEB SAYT)",
        url: "/events",
        role: ["admin", "pre-admin"],
        icon: <FeedIcon />
    },
    {
        name: "Xodimlar (WEB SAYT)",
        url: "/stuffs",
        role: ["admin"],
        icon: <GroupAddIcon />
    },
    {
        name: "Galereya (WEB SAYT)",
        url: "/gallery",
        role: ["pre-admin", "admin"],
        icon: <AddPhotoAlternateIcon />
    },
    {
        src: "",
        url: "/profile",
        role: ["user", "pre-admin", "admin"],
        icon: <ManageAccountsIcon />
    },
    {
        name: "Chiqish",
        url: "/login",
        role: ["admin"],
        icon: <LogoutIcon sx={{ color: "white" }} />
    },

    
]

export { users_table_headers, categories_table_headers, status_table_headers, navbarData, excelTableHeaders, fakulties }